import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-success-check",
  "use": "icon-success-check-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-success-check\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"currentColor\" cx=\"6\" cy=\"6\" r=\"6\" /><path stroke=\"#FFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.388 5.715l1.977 2.113 3.206-3.356\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol